export default "__VITE_ASSET__BOCE_icu__"